<div *ngIf="time">
  {{time | amFromUnix | amTimeAgo}}
</div>
